var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { SAIcon, SAIcons, SAIconSize } from '../icon';
import { setHSLLighness } from '../utilities';
var Accordion = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return "\n      display: flex;\n      flex-direction: column;\n      margin-top: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + ";\n      margin-bottom: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + ";\n\n      &::first-child {\n        margin-top: 0px;\n        margin-bottom: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + ";\n      }\n\n      &::last-child {\n        margin-top: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + ";\n        margin-bottom: 0px;\n      }\n\n      button[type='button']:focus ~ .accordion-summary {\n        background-color: " + setHSLLighness(theme === null || theme === void 0 ? void 0 : theme.color.background.background, 93) + ";\n      }\n    ";
});
var AccordionSummary = styled.div.attrs(function (_a) {
    var disabled = _a.disabled;
    return ({
        disabled: disabled,
    });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    var color = disabled ? '#999999' : theme === null || theme === void 0 ? void 0 : theme.colors.text;
    var cursor = disabled ? 'initial' : 'pointer';
    return "\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      background: " + (theme === null || theme === void 0 ? void 0 : theme.color.background.background) + ";\n      height: 44px;\n      padding: 4px 20px;\n      box-sizing: border-box;\n      color: " + color + ";\n      cursor: " + cursor + ";\n      overflow-x: clip;\n\n      &::focus {\n        backgroun: lightblue;\n      }\n    ";
});
var AccordionBody = styled.div.attrs(function (_a) {
    var open = _a.open;
    return ({
        open: open,
    });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var open = _a.open, theme = _a.theme;
    var display = open ? 'flex' : 'none';
    return "\n      display: " + display + ";\n      flex-direction: column;\n      padding: calc(" + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + " + 5px);\n    ";
});
var AccordionDetails = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var AccordionActions = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return "\n      display: flex;\n      flex-direction: row;\n      justify-content: flex-end;\n      padding-top: calc(" + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + " + 5px);\n      flex-wrap: wrap;\n\n      button {\n        margin-left: 5px;\n        margin-right: 5px;\n      }\n\n      button:first-child {\n        margin-left: 0px;\n        margin-right: 5px;\n      }\n\n      button:last-child {\n        margin-left: 5px;\n        margin-right: 0px;\n      }\n    ";
});
var Container = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Title = styled.span.attrs(function (_a) {
    var textTransform = _a.textTransform;
    return ({
        textTransform: textTransform,
    });
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var textTransform = _a.textTransform, theme = _a.theme;
    return "\n      display: flex;\n      flex-direction: row;\n      font-family: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.family) + ";\n      font-size: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.size.smallTEMP) + ";\n      font-weight: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.bold) + ";\n      line-height: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.size.smallTEMP) + ";\n      text-transform: " + textTransform + ";\n      padding-right: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + ";\n    ";
});
var Tag = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var Buttons = styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var Icon = styled.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return "\n      display: flex;\n      flex-direciton: row;\n      padding-left: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + ";\n    ";
});
var InvisibleButton = styled.button(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var disabled = _a.disabled;
    var pointer = disabled ? 'initial' : 'pointer';
    return "\n      position: absolute;\n      opacity: 0;\n      cursor: " + pointer + ";\n    ";
});
export function SAAccordion(_a) {
    var actions = _a.actions, buttons = _a.buttons, children = _a.children, disabled = _a.disabled, expanded = _a.expanded, id = _a.id, onChange = _a.onChange, tag = _a.tag, textTransform = _a.textTransform, title = _a.title, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    variant = _a.variant, rest = __rest(_a, ["actions", "buttons", "children", "disabled", "expanded", "id", "onChange", "tag", "textTransform", "title", "variant"]);
    var _b = useState(expanded), open = _b[0], setOpen = _b[1];
    var expandIcon = disabled ? (React.createElement(SAIcon, { icon: SAIcons.chevronDownBold, size: SAIconSize.small, colorVariant: "#999999" })) : (React.createElement(SAIcon, { icon: SAIcons.chevronDownBold, size: SAIconSize.small, colorVariant: "secondary" }));
    var collapseIcon = React.createElement(SAIcon, { icon: SAIcons.chevronUpBold, size: SAIconSize.small, colorVariant: "secondary" });
    var icon = open ? collapseIcon : expandIcon;
    function toggleAccordion(e) {
        if (!disabled) {
            setOpen(!open);
            if (onChange) {
                onChange(e, !open);
            }
        }
    }
    useEffect(function () {
        setOpen(expanded);
    }, [expanded]);
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Accordion, __assign({ className: "accordion-root" }, rest),
        React.createElement(InvisibleButton, { type: "button", onClick: toggleAccordion, id: id + "-accordion-title", "aria-controls": id + "-accordion-content", "aria-expanded": open, disabled: disabled }, title),
        React.createElement(AccordionSummary, { className: "accordion-summary", disabled: disabled, onClick: toggleAccordion },
            React.createElement(Container, { className: "accordion-container" },
                React.createElement(Title, { className: "accordion-title", textTransform: textTransform }, title),
                tag && React.createElement(Tag, { className: "accordion-tag" }, tag)),
            React.createElement(Container, { className: "accordion-container" },
                buttons && !disabled && React.createElement(Buttons, { className: "accordion-buttons" }, buttons),
                React.createElement(Icon, { className: "accordion-icon" }, icon))),
        React.createElement(AccordionBody, { open: open, id: id + "-accordion-content", "aria-labelledby": id + "-accordion-title", "aria-hidden": !open, role: "region", className: "accordion-body" },
            React.createElement(AccordionDetails, { className: "accordion-details" }, children),
            actions && React.createElement(AccordionActions, { className: "accordion-actions" }, actions))));
}
SAAccordion.defaultProps = {
    actions: undefined,
    buttons: undefined,
    disabled: false,
    expanded: false,
    onChange: undefined,
    tag: undefined,
    textTransform: 'none',
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=accordion.component.js.map